module.exports = __webpack_public_path__ + "img/7d786e6.png";